import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { useShellHistoryListener } from 'src/core/hooks/useShellHistoryListener';
import { QueryKeys } from 'src/core/router/constants';
import { FreeSignupModal } from 'src/modules/product/components/freeSignupModal';
import { useQueryParams } from 'src/shared/hooks/useQueryParams';
export function Root() {
    useShellHistoryListener();
    const freeSignupModalQueryParam = useQueryParams(QueryKeys.ConfigureFreeSignup);
    return (_jsxs(_Fragment, { children: [freeSignupModalQueryParam.hasQueryParam() && (_jsx(FreeSignupModal, { onCloseModal: freeSignupModalQueryParam.removeQueryParam })), _jsx(Outlet, {})] }));
}
